// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3NVaN","signatureButtonsRight":"ModalSign_signatureButtonsRight__1rFSI"};